module.exports = __webpack_public_path__ + "static/media/arrow-down.a97ddaa9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-down.svg
// module id = 283
// module chunks = 7